// extracted by mini-css-extract-plugin
module.exports = {"bottomNav":"styles_bottomNav__31Coz","bottomNavItem":"styles_bottomNavItem__3ewAa","bottomNavDots":"styles_bottomNavDots__3yDo-","bottomNavActive":"styles_bottomNavActive__39Z2x"};